import "./successCard.scss";
import Logo from "../../assets/images/logo.svg";
import EmailTick from "../../assets/images/email-tick.svg";

export default function SuccessCard({ message }) {
  return (
    <div className="successCard">
        <img src={Logo} alt="logo" className="logo" />
        <div className="message">
          <img src={EmailTick} alt="email" />
          <p>
            {message}
          </p>
        </div>
    </div>
  );
}
